import { render, staticRenderFns } from "./RegistrationAddress.vue?vue&type=template&id=7e095084"
import script from "./RegistrationAddress.vue?vue&type=script&lang=js"
export * from "./RegistrationAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports